<template>
    <div>
        <div class="operation-box">
            <div>
                <el-button @click="clickReturnBtn" v-show="viewPart == 'edit'" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
                &nbsp;
            </div>

            <div>
                <el-button type="primary" @click="clickAddBtn" v-show="viewPart == 'list'" tkey="添加">{{i18n.tkey("lang_add")}}</el-button>
            </div>
        </div>

        <div v-show="viewPart == 'list'">
            <el-table :data="regionSettingList" style="width: 100%">
                <el-table-column :label="i18n.tkey('lang_area_text')" >
                    <template #default="scope">
                        <span>{{(userInfoRef.lang == "zh" || userInfoRef.lang == "szh") ? scope.row.CountryName : scope.row.CountryName2}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="PriceFrom" :label="i18n.tkey('lang_min_buy_qty')" />
                <el-table-column :label="i18n.tkey('lang_d_cost')" >
                    <template #default="scope">
                        <span>{{scope.row.DeliveryFee}} {{scope.row.Curr}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="i18n.tkey('lang_operate')" >
                    <template #default="scope">
                        <el-button type="primary" size="small" @click="clickEditBtn(scope.row)">
                            <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                        </el-button>

                        <div class="next-line-div">

                        </div>

                        <el-button type="danger" size="small" @click="clickDelBtn(scope.row)">
                            <font-awesome-icon icon="fa-solid fa-trash" />
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="viewPart == 'edit'">
            <insertOrEditTransportRegionSetting :editObj="editObj" @clickAdd="addCallback" @clickEdit="saveCallback" />
        </div>

    </div>
</template>

<script setup>
    import {inject, ref, onBeforeMount, onMounted, watch, toRef} from "vue";
    import insertOrEditTransportRegionSetting from "@/components/shopopee/material/insertOrEditTransportRegionSetting"
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faTrash, faPenToSquare } from '@fortawesome/free-solid-svg-icons'
    import myUtil from "@/util/util";
    import {useUserinfo} from "@/stores/userinfo";

    library.add(faTrash, faPenToSquare)

    const props = defineProps(['modelValue'])
    const emits = defineEmits(['update:modelValue'])

    const i18n = inject("i18n")

    const userInfoRef = toRef(useUserinfo())
    const regionSettingList = ref([])
    const deleteList = []
    const viewPart = ref("list")
    const editObj = ref(null)

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const shopCompany = ref({})

    watch(() => props.modelValue, (newValue, oldValue) => {
        regionSettingList.value = newValue
    })

    function clickAddBtn() {
        editObj.value = null
        viewPart.value = "edit"
    }

    function clickEditBtn(obj) {
        viewPart.value = "edit"
        editObj.value = obj
    }

    function clickReturnBtn(){
        editObj.value = null
        viewPart.value = "list"
    }

    function clickDelBtn(obj){
        if (myUtil.isNotEmpty(obj.viewId)){
            for (let i=0; i<regionSettingList.value.length; i++){
                const info = regionSettingList.value[i]

                if (null != info.viewId && info.viewId == obj.viewId){
                    regionSettingList.value.splice(i, 1)
                    break
                }

            }
        }else{
            for (let i=0; i<regionSettingList.value.length; i++){
                const info = regionSettingList.value[i]

                if (null != info.ID && info.ID == obj.ID){
                    info.delTag = true
                    deleteList.push(regionSettingList.value.splice(i, 1)[0])
                    break
                }

            }
        }

        emits("update:modelValue", regionSettingList.value)
    }

    function addCallback(obj){
        obj.CompanyCode = shopCompany.value.acccompanycode

        regionSettingList.value.push(obj)
        clickReturnBtn()

        emits("update:modelValue", regionSettingList.value)
    }

    function saveCallback(obj){
        if (myUtil.isNotEmpty(obj.viewId)){
            for (let i=0; i<regionSettingList.value.length; i++){
                const info = regionSettingList.value[i]

                if (null != info.viewId && info.viewId == obj.viewId){
                    regionSettingList.value[i] = obj
                    break
                }

            }
        }

        clickReturnBtn()

        emits("update:modelValue", regionSettingList.value)
    }

    function getDelList(){
        return deleteList
    }

    defineExpose({
        getDelList
    })

    onBeforeMount(() => {
        regionSettingList.value = props.modelValue
        shopCompany.value = getShopCompanyObj()
    })

</script>

<style scoped>

    .operation-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    @media screen and (min-width: 768px) {
        .next-line-div {
            display: inline-block;
            width: 10px;
        }
    }

    @media screen and (max-width: 768px) {
        .next-line-div {
            height: 10px;
        }
    }

</style>